"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _creative = require("../../constants/creative");

var _text = require("../../constants/text");

var _getNumericFontValue = _interopRequireDefault(require("../../utils/font/getNumericFontValue"));

var _wrapFontFamilyInQuotes = _interopRequireDefault(require("../../utils/font/wrapFontFamilyInQuotes"));

var _convertObjectToMap = _interopRequireDefault(require("../../utils/object/convertObjectToMap"));

var _deepCopy = _interopRequireDefault(require("../../utils/object/deepCopy"));

var _isNotNil = _interopRequireDefault(require("../../utils/object/isNotNil"));

var _isArray = _interopRequireDefault(require("../../utils/object/isArray"));

var TextProperties = /*#__PURE__*/function () {
  // TODO create class/type for this
  function TextProperties(_ref) {
    var fillColor = _ref.fillColor,
        fillProperties = _ref.fillProperties,
        fontName = _ref.fontName,
        fontSize = _ref.fontSize,
        horizontalAlignment = _ref.horizontalAlignment,
        letterSpacing = _ref.letterSpacing,
        lineSpacing = _ref.lineSpacing,
        naturalHeight = _ref.naturalHeight,
        naturalWidth = _ref.naturalWidth,
        overflowY = _ref.overflowY,
        padding = _ref.padding,
        renderedFontSize = _ref.renderedFontSize,
        strokeColor = _ref.strokeColor,
        strokeWidth = _ref.strokeWidth,
        textEffect = _ref.textEffect,
        textLines = _ref.textLines,
        textString = _ref.textString,
        verticalAlignment = _ref.verticalAlignment,
        wrapProperties = _ref.wrapProperties;
    (0, _classCallCheck2["default"])(this, TextProperties);
    (0, _defineProperty2["default"])(this, "_fillColor", _creative.DEFAULT_FILL_COLOR);
    (0, _defineProperty2["default"])(this, "_fillProperties", (0, _convertObjectToMap["default"])(_text.DEFAULT_TEXT_FILL_PROPERTIES));
    (0, _defineProperty2["default"])(this, "_fontName", 'sans serif');
    (0, _defineProperty2["default"])(this, "_fontSize", _text.DEFAULT_FONT_SIZE);
    (0, _defineProperty2["default"])(this, "_horizontalAlignment", _text.TEXT_ALIGNMENT.LEFT);
    (0, _defineProperty2["default"])(this, "_letterSpacing", _text.DEFAULT_LETTER_SPACING);
    (0, _defineProperty2["default"])(this, "_lineSpacing", _text.DEFAULT_LINE_SPACING);
    (0, _defineProperty2["default"])(this, "_naturalHeight", null);
    (0, _defineProperty2["default"])(this, "_naturalWidth", 0);
    (0, _defineProperty2["default"])(this, "_overflowY", _text.OVERFLOW_Y.VISIBLE);
    (0, _defineProperty2["default"])(this, "_padding", 0);
    (0, _defineProperty2["default"])(this, "_renderedFontSize", null);
    (0, _defineProperty2["default"])(this, "_strokeColor", _text.DEFAULT_STROKE_COLOR);
    (0, _defineProperty2["default"])(this, "_strokeWidth", _text.DEFAULT_STROKE_WIDTH);
    (0, _defineProperty2["default"])(this, "_textEffect", (0, _convertObjectToMap["default"])(_text.DEFAULT_TEXT_EFFECTS_OBJECTS[_text.TEXT_EFFECTS.NONE]));
    (0, _defineProperty2["default"])(this, "_naturalHeight", 0);
    (0, _defineProperty2["default"])(this, "_textString", 'Text Placeholder');
    (0, _defineProperty2["default"])(this, "_verticalAlignment", _text.VERTICAL_TEXT_ALIGNMENT.TOP);
    (0, _defineProperty2["default"])(this, "_wrapProperties", (0, _convertObjectToMap["default"])({
      breakWord: false,
      height: 500,
      width: 1000
    }));
    // TODO optional assign if valid values
    this._fillColor = fillColor;
    this._fillProperties = (0, _deepCopy["default"])(fillProperties);
    this._fontName = (0, _wrapFontFamilyInQuotes["default"])(fontName);
    this._fontSize = (0, _getNumericFontValue["default"])(fontSize);
    this._horizontalAlignment = horizontalAlignment;
    this._letterSpacing = letterSpacing;
    this._lineSpacing = lineSpacing;
    this._naturalHeight = naturalHeight;
    this._naturalWidth = naturalWidth;
    this._overflowY = overflowY;
    this._padding = padding;
    this._renderedFontSize = (0, _isNotNil["default"])(renderedFontSize) ? (0, _getNumericFontValue["default"])(renderedFontSize) : this._fontSize;
    this._strokeColor = strokeColor;
    this._strokeWidth = strokeWidth;
    this._textEffect = textEffect;

    if ((0, _isArray["default"])(textLines)) {
      this._textLines = (0, _deepCopy["default"])(textLines);
    }

    this._textString = textString;
    this._verticalAlignment = verticalAlignment;

    if ((0, _isNotNil["default"])(wrapProperties)) {
      this._wrapProperties = (0, _deepCopy["default"])(wrapProperties);
    }
  }

  (0, _createClass2["default"])(TextProperties, [{
    key: "copy",
    value: function copy() {
      return new TextProperties(this);
    }
  }, {
    key: "fillColor",
    get: function get() {
      return this._fillColor;
    },
    set: function set(value) {
      this._fillColor = value;
    }
  }, {
    key: "fillProperties",
    get: function get() {
      return this._fillProperties;
    },
    set: function set(value) {
      this._fillProperties = value;
    }
  }, {
    key: "fontName",
    get: function get() {
      return this._fontName;
    },
    set: function set(value) {
      this._fontName = value;
    }
  }, {
    key: "fontSize",
    get: function get() {
      return this._fontSize;
    },
    set: function set(value) {
      this._fontSize = value;
    }
  }, {
    key: "horizontalAlignment",
    get: function get() {
      return this._horizontalAlignment;
    },
    set: function set(value) {
      this._horizontalAlignment = value;
    }
  }, {
    key: "letterSpacing",
    get: function get() {
      return this._letterSpacing;
    },
    set: function set(value) {
      this._letterSpacing = value;
    }
  }, {
    key: "lineSpacing",
    get: function get() {
      return this._lineSpacing;
    },
    set: function set(value) {
      this._lineSpacing = value;
    }
  }, {
    key: "naturalHeight",
    get: function get() {
      return this._naturalHeight;
    },
    set: function set(value) {
      this._textLines = value;
    }
  }, {
    key: "naturalWidth",
    get: function get() {
      return this._naturalWidth;
    },
    set: function set(value) {
      this._naturalWidth = value;
    }
  }, {
    key: "overflowY",
    get: function get() {
      return this._overflowY;
    },
    set: function set(value) {
      this._overflowY = value;
    }
  }, {
    key: "padding",
    get: function get() {
      return this._padding;
    },
    set: function set(value) {
      this._padding = value;
    }
  }, {
    key: "renderedFontSize",
    get: function get() {
      return this._renderedFontSize;
    },
    set: function set(value) {
      this._renderedFontSize = value;
    }
  }, {
    key: "strokeColor",
    get: function get() {
      return this._strokeColor;
    },
    set: function set(value) {
      this._strokeColor = value;
    }
  }, {
    key: "strokeWidth",
    get: function get() {
      return this._strokeWidth;
    },
    set: function set(value) {
      this._strokeWidth = value;
    }
  }, {
    key: "textEffect",
    get: function get() {
      return this._textEffect;
    },
    set: function set(value) {
      this._textEffect = value;
    }
  }, {
    key: "textLines",
    get: function get() {
      return this._textLines;
    } // Rendered text lines
    ,
    set: function set(value) {
      this._textLines = value;
    }
  }, {
    key: "textString",
    get: function get() {
      return this._textString;
    },
    set: function set(value) {
      this._textString = value;
    }
  }, {
    key: "verticalAlignment",
    get: function get() {
      return this._verticalAlignment;
    },
    set: function set(value) {
      this._verticalAlignment = value;
    }
  }, {
    key: "wrapProperties",
    get: function get() {
      return this._wrapProperties;
    },
    set: function set(value) {
      this._wrapProperties = value;
    }
  }], [{
    key: "isTextProeprties",
    value: function isTextProeprties(textProperties) {
      return textProperties instanceof TextProperties;
    }
  }]);
  return TextProperties;
}();

exports["default"] = TextProperties;